import { BASE_URL } from './BASE_URL';

export const getMP = async (id) => {
  const response = await fetch(
    BASE_URL + `master-plan/master-plan-territory/${id}`
  );
  const data = await response.json();
  return data;
};
